import React, { useState } from 'react';
import { HelpCircle, Sparkles, Send } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
import { faqs } from '../../data/education/faqs';
import { useFAQAnswer } from '../../hooks/useEducationContent';

export function FrequentlyAskedQuestions() {
  const [customQuestion, setCustomQuestion] = useState('');
  const [askAI, setAskAI] = useState(false);
  const { data: aiAnswer, isLoading: answerLoading } = useFAQAnswer(customQuestion, askAI);

  const handleAskQuestion = (e: React.FormEvent) => {
    e.preventDefault();
    if (customQuestion.trim()) {
      setAskAI(true);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="relative h-48">
        <img
          src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40"
          alt="Questions and answers about forex trading"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 to-emerald-800/60" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white">
            <HelpCircle className="h-12 w-12 mx-auto mb-2" />
            <h2 className="text-2xl font-bold">Frequently Asked Questions</h2>
          </div>
        </div>
      </div>
      <div className="p-6">
        <div className="mb-6 p-4 bg-gradient-to-r from-emerald-50 to-blue-50 rounded-lg border border-emerald-200">
          <div className="flex items-center gap-2 mb-3">
            <Sparkles className="h-5 w-5 text-emerald-600" />
            <h3 className="font-semibold text-emerald-900">Ask AI Anything</h3>
          </div>
          <form onSubmit={handleAskQuestion} className="space-y-3">
            <div className="flex gap-2">
              <input
                type="text"
                value={customQuestion}
                onChange={(e) => {
                  setCustomQuestion(e.target.value);
                  setAskAI(false);
                }}
                placeholder="Ask any question about Nigerian forex trading..."
                className="flex-1 px-4 py-2 border border-emerald-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500"
              />
              <button
                type="submit"
                disabled={!customQuestion.trim() || answerLoading}
                className="px-6 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {answerLoading ? (
                  <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                ) : (
                  <Send className="h-5 w-5" />
                )}
              </button>
            </div>
          </form>

          {aiAnswer && (
            <div className="mt-4 p-4 bg-white rounded-lg border border-emerald-200">
              <div className="flex items-start gap-2 mb-2">
                <Sparkles className="h-4 w-4 text-emerald-600 mt-1 flex-shrink-0" />
                <p className="font-medium text-emerald-900">AI Answer:</p>
              </div>
              <p className="text-gray-700 leading-relaxed">{aiAnswer}</p>
            </div>
          )}
        </div>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-200 last:border-0 pb-6 last:pb-0">
              <h3 className="font-semibold text-lg mb-2">{faq.question}</h3>
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}